export const CHANGE_MODAL_MULTI_FILTER = 'CHANGE_MODAL_MULTI_FILTER'
export const CHANGE_MODAL_PROPERTY_TYPE = 'CHANGE_MODAL_PROPERTY_TYPE'
export const CLEAR_MULTI_FILTER = 'CLEAR_MULTI_FILTER'
export const TOGGLE_FILTER = 'TOGGLE_FILTER'
export const CHANGE_SORTING = 'CHANGE_SORTING'
export const CHANGE_POPULAR_CITY = 'CHANGE_POPULAR_CITY'
export const CHANGE_PAGE = 'CHANGE_PAGE'

export const CHANGE_LOCATION_FILTER = 'CHANGE_LOCATION_FILTER'

export const SELECT_SEARCHED_RESULT = 'SELECT_SEARCHED_RESULT'
export const CHANGE_SEARCH_CONTENT = 'CHANGE_SEARCH_CONTENT'
export const CHANGE_SPECIAL_FEATURE = 'CHANGE_SPECIAL_FEATURE'
export const CLEAR_SEARCH_CONTENT = 'CLEAR_SEARCH_CONTENT'
export const CHANGE_PROPERTY_TYPE = 'CHANGE_PROPERTY_TYPE'
export const CHANGE_PROPERTY_SUB_TYPE = 'CHANGE_PROPERTY_SUB_TYPE'
export const CHANGE_TO_ANY = 'CHANGE_TO_ANY'
export const CLEAR_ALL = 'CLEAR_ALL'
export const RESET_PAGE_NO = 'RESET_PAGE_NO'
export const FOOTER_LOC = "FOOTER_LOC"

